const loyaltyPointsCalculator = require('../loyalty/loyalty-points-calculator');

module.exports = function (settings) {
    const conversionBaseSetting = settings.loyalty.rewardsConversionBase;

    function wowLoyaltyFilter(amount, shouldRestrictToMax = false) {
        if (conversionBaseSetting) {
            return loyaltyPointsCalculator(amount, conversionBaseSetting, shouldRestrictToMax);
        }

        return amount;
    }

    // This filter is stateful because it depends on the setting value for the conversion base.
    // See https://docs.angularjs.org/guide/filter#stateful-filters
    wowLoyaltyFilter.$stateful = true;

    return wowLoyaltyFilter;
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-loyalty-points.js